<div class="container">
  <div class="free-trial-form-container">
    <div class="trial-form-slider-section">

      <!-- <p class="f-18 font-weight-600 mb-4">
        Talent Discovery
      </p>
      <p class="parot-green">Supercharge Your Hiring with Data-Driven Insights – Start Your Free Trial Today!</p> -->
      <!-- <div class="separator">&nbsp;</div> -->


      <div class="slider-container">
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-bs-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
            <li data-bs-target="#carouselExampleIndicators" data-slide-to="1"></li>
            <li data-bs-target="#carouselExampleIndicators" data-slide-to="2"></li>
            <li data-bs-target="#carouselExampleIndicators" data-slide-to="3"></li>
            <li data-bs-target="#carouselExampleIndicators" data-slide-to="4"></li>
            <li data-bs-target="#carouselExampleIndicators" data-slide-to="5"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <p class="f-14 font-weight-normal mb-4">Analyze diversity insights to build <br>inclusive teams.</p>

              <img src="../../../assets/webbtree-freemium/Analyze-diverity-insights-slider1.svg" class="img-fluid" alt="...">
            </div>
            <div class="carousel-item">
              <p class="f-14 font-weight-normal mb-4">Track talent movement to source from growing or shrinking companies.
              </p>

              <img src="../../../assets/webbtree-freemium/Track-talent-movement-slider1.svg" class="img-fluid" alt="...">
            </div>
            <div class="carousel-item">
              <p class="f-14 font-weight-normal mb-4">Discover top skills and titles for high-demand roles.</p>

              <img src="../../../assets/webbtree-freemium/Discover-top-skills-and-titles-slider1.svg" class="img-fluid"
                alt="...">
            </div>
            <div class="carousel-item">
              <p class="f-14 font-weight-normal mb-4">Leverage seniority and nationality insights for targeted sourcing.</p>

              <img src="../../../assets/webbtree-freemium/Leverage-seniority-and-nationality-insights-slider1.svg" class="img-fluid" alt="...">
            </div>
            <div class="carousel-item">
              <p class="f-14 font-weight-normal mb-4">Target candidates using company talent flow and attrition trends.</p>

              <img src="../../../assets/webbtree-freemium/tgtcdtsldr1.svg" class="img-fluid" alt="...">
            </div>

            <div class="carousel-item">
              <p class="f-14 font-weight-normal mb-4">Access 610M+ profiles with contact information for outreach.</p>

              <img src="../../../assets/webbtree-freemium/Access-profiles-with-contact-slider1.svg" class="img-fluid" alt="...">
            </div>
          </div>
          <button data-testid="auto-app-talent-insights-free-trial-form-button-1" class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
            data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </button>
          <button data-testid="auto-app-talent-insights-free-trial-form-button-2" class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
            data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </button>
        </div>
      </div>
    </div>
    <div class="trial-form-section">
      <p class="f-32 font-weight-600 text-black mb-4">Start 7-Day <span style="color: #2E93A1;"> Free Trial</span></p>
      <p class="f-14  mb-3">Join 5,000+ recruiters already discovering smarter sourcing with Webbtree.
        </p>
        <p class="f-14  font-weight-normal mb-5" style="font-style: italic;">No credit card needed — free for 7 days.</p>
              <p class="f-14 font-weight-500 text-969696 mb-3">Enter your details here</p>

      <form [formGroup]="freeTrialForm">
    <div class="row">
          <div class="col">
             <!-- <label for="Workemail">Work email<span class="text-danger">*</span></label> -->
            <div class="input-form-linkedin-box  mb-0">
              <div class="linkedinbox">
                <input data-testid="auto-app-talent-insights-free-trial-form-input-1" type="text" placeholder="Enter your Work email here" class="wc-form-control"
              formControlName="workEmail">
              <div class="posrelativeinmobile">
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;"
                 *ngIf="freeTrialForm['controls'].workEmail.hasError('required') && (freeTrialForm['controls'].workEmail.dirty || freeTrialForm['controls'].workEmail.touched)">
                  This field is required</p>
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;" *ngIf="freeTrialForm['controls'].workEmail.hasError('pattern')">
                  Invalid Email Id</p>
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;" *ngIf="freeTrialForm['controls'].workEmail.hasError('invaliDomain')">
                  Invalid Domain</p>
                
              </div>
              </div>
              <div>
                <button data-testid="auto-app-talent-insights-free-trial-form-button-3" class="btn-form-submit btn-disable" [ngClass]="{'btn-active': freeTrialForm?.valid}"
                  (click)="register()">
                  <span [ngClass]="{ 'spinner-border text-light spinner-size': showFreeTrialLoader}" [ngStyle] = "{ 'width: 250px; height: 20px;': showFreeTrialLoader }">
                    {{showFreeTrialLoader ? '' : 'Start Free Trial >'}}
                  </span>
                  </button>
              </div>
            </div>


          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-6 mb-5">
            <label for="firstname">First Name<span class="text-danger">*</span></label>
            <input data-testid="auto-app-talent-insights-free-trial-form-input-2" type="text" placeholder="Enter your First Name" class="wc-form-control" formControlName="firstName">
            <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;"
              *ngIf="freeTrialForm['controls'].firstName.hasError('required') && (freeTrialForm['controls'].firstName.dirty || freeTrialForm['controls'].firstName.touched)">
              This field is required</p>
          </div>
          <div class="col-md-6 mb-5">
            <label for="lastname">Last Name<span class="text-danger">*</span></label>
            <input data-testid="auto-app-talent-insights-free-trial-form-input-3" type="text" placeholder="Enter your Last Name" class="wc-form-control" formControlName="lastName">
            <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;"
              *ngIf="freeTrialForm['controls'].lastName.hasError('required') && (freeTrialForm['controls'].lastName.dirty || freeTrialForm['controls'].lastName.touched)">
              This field is required</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-5">
            <label for="companyname">Company Name<span class="text-danger">*</span></label>
            <input data-testid="auto-app-talent-insights-free-trial-form-input-4" type="text" placeholder="e.g. Google, Amazon" class="wc-form-control"
              formControlName="companyname">
            <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;"
              *ngIf="freeTrialForm['controls'].companyname.hasError('required') && (freeTrialForm['controls'].companyname.dirty || freeTrialForm['controls'].companyname.touched)">
              This field is required</p>
          </div>
          <div class="col-md-6 mb-5">
            <label for="Designation">Designation<span class="text-danger">*</span></label>
            <input data-testid="auto-app-talent-insights-free-trial-form-input-5" type="text" placeholder="e.g. Software Engineer" class="wc-form-control"
              formControlName="designation">
            <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;"
              *ngIf="freeTrialForm['controls'].designation.hasError('required') && (freeTrialForm['controls'].designation.dirty || freeTrialForm['controls'].designation.touched)">
              This field is required</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-5">
            <label for="Workemail">Work email<span class="text-danger">*</span></label>
            <input data-testid="auto-app-talent-insights-free-trial-form-input-6" type="text" placeholder="Enter your Work email" class="wc-form-control"
              formControlName="workEmail">
            <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;"
              *ngIf="freeTrialForm['controls'].workEmail.hasError('required') && (freeTrialForm['controls'].workEmail.dirty || freeTrialForm['controls'].workEmail.touched)">
              This field is required</p>
            <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;" *ngIf="freeTrialForm['controls'].workEmail.hasError('pattern')">
              Invalid Email Id</p>
            <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;" *ngIf="freeTrialForm['controls'].workEmail.hasError('invaliDomain')">
              Invalid Domain</p>
          </div>
          <div class="col-md-6 mb-5">
            <label for="PhoneNumber">Phone Number<span class="text-danger">*</span></label>
            <div class="input-form-number-box">
              <div class="position-relative">
              <ngx-intl-tel-input [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true" [searchCountryFlag]="true" [preferredCountries]="['in']"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                [phoneValidation]="true" name="phone" [separateDialCode]="true"
                formControlName="phoneNumber" class="d-block">
              </ngx-intl-tel-input>
              <div class="posrelativeinmobile">
                <p *ngIf="freeTrialForm.get('phoneNumber').errors?.required && freeTrialForm['controls'].phoneNumber.touched"
                class="f-12 text-danger mb-0 mt-1"> Phone number is required</p>
              <p class="text-danger f-12 pt-1 mb-0"
                *ngIf="freeTrialForm?.value?.phoneNumber && !freeTrialForm.controls['phoneNumber'].valid && (freeTrialForm['controls'].phoneNumber.touched)">
                Invalid phone number</p>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label for="linkedinUrl">Linkedin URL<span class="text-danger">*</span></label>
            <div class="input-form-linkedin-box  mb-0">
              <div class="linkedinbox">
                <input data-testid="auto-app-talent-insights-free-trial-form-input-7" type="text" placeholder="Enter your Linkedin URL" class="wc-form-control"
                formControlName="linkedinUrl">
              <div class="posrelativeinmobile">
                <div *ngIf="freeTrialForm.controls['linkedinUrl'].invalid && freeTrialForm.controls['linkedinUrl'].touched">
                  <small class="text-danger mt-1 mb-1" *ngIf="freeTrialForm.controls['linkedinUrl'].hasError('required')">LinkedIn URL is required.</small>
                  <small class="text-danger mt-1 mb-1" *ngIf="freeTrialForm.controls['linkedinUrl'].hasError('pattern')">Please enter a valid LinkedIn URL.</small>
                </div>
              </div>
              </div>
              <div>
                <button data-testid="auto-app-talent-insights-free-trial-form-button-4" class="btn-form-submit btn-disable" [ngClass]="{'btn-active': freeTrialForm?.valid}"
                  (click)="register()">
                  <span [ngClass]="{ 'spinner-border text-light spinner-size': showFreeTrialLoader}" [ngStyle] = "{ 'width: 250px; height: 20px;': showFreeTrialLoader }">
                    {{showFreeTrialLoader ? '' : 'Start Free Trial >'}}
                  </span>
                  </button>
              </div>
            </div>


          </div>
        </div> -->
        <div class="row mt-5">
          <div class="col">
            <p class="f-12 text-484b59">By proceeding, you agree to our <a data-testid="auto-app-talent-insights-free-trial-form-a-1" class="text-webbtree-green" href="https://www.webbtree.com/terms-and-conditions" target="_blank">Terms & Conditions</a> and <a data-testid="auto-app-talent-insights-free-trial-form-a-2" class="text-webbtree-green" href="https://www.webbtree.com/privacy-policy" target="_blank">Privacy Policy</a></p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="text-danger f-12 pt-1" *ngIf="showErrorMsg">{{showErrorMsg}}</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #freeTrialSuccess>
  <div>
    <div class="text-center" style="padding: 50px;">
      <img src="../../../assets/images/freetrialsuccess.png" alt="" class="img-success">
      <p class="f-16 font-weight-600 green-color">Success!</p>
      <p class="f-14 font-weight-500">Your Free Trial Request is Received. </p>
      <div>
        <p>Thank you for your interest in Webbtree Talent Insights! Our team is setting up your free trial account, and
          you'll hear from us within 24 hours. Keep an eye on your inbox for login details and next steps.

        </p>
      </div>
      <div>
        <button data-testid="auto-app-talent-insights-free-trial-form-button-5" class="btn-trms-small-regular" (click)="modalService.dismissAll()">Close</button>

      </div>

    </div>
  </div>
</ng-template>
